export const wording = {
	microscope: {
		x5: 'Les entités',
		x10: 'Entre les entités',
		x100: 'Dans les entités',
	},
	landing: {
		button: "Entrer dans l'experience",
	},
};

export const options3D = {
	x5: {
		cameraPosition: {
			x: 9.951367378234863,
			y: 16.248703002929688,
			z: 15.341559410095215,
		},
		cameraAnimationDuration: 6255, // according to frame it should be 6250 but we add 5ms for latency issues
		experienceCamera: { // oldcamera only used for developeent purpose
			x: 0,
			y: 0,
			z: 15,
			_z: 500, // initial Z used for entiy animations
			_s: 20, // camera speed
		},
        experienceFreeCamera:{
            x: -1.5,
			y: 1.5,
			z: 18,
        },
		sphere: {
			diameter: 2.5,
			segments: 32,
			_s: 20,
		},
	},
	x10: {
		sphere: {
			diameter: 0.5,
			segments: 32,
			sphereInitial_z: 0,
			_r: 1.8,
			_z: -600, // initial Z used for services animations
			_s: 20, // services speed
			_rand: 20,
		},
		tube: {
			color: [0, 0, 0],
			diameter: 0.04,
		},
	},
	x100: {
		camera: {
			_z: -690,
			_s: 6, // colaborator camera speed
		},
		atome: {
			rotation: {
				x:Math.PI / 16, // rotation should be an angle
				y: Math.PI /24, // rotation should be an angle
				z: 0, // rotation should be an angle
			},
			z: -700,
		},
		peoplesScale: {
			exec: 1,
			manager: 0.5,
			people: 0.3,
		},
	},
	globalApparitionSector: {
		// % in viewport
		x: 25,
		y: 0,
		width: 75,
		height: 85,
	},
	deskTimeOut: 5,
};
export const flags = {
	animation: {
		landingEntity: true,
	},
	mouvement: {
		entity: false,
		services: false,
	},
    "3d": true,
    rotateCamera: true
};

export const entitiesNames = {
	VR3D: 'gta-vr3d',
	VM: 'gta-vm',
	GE: 'gta-ge',
	ENVI: 'gta-environement',
	NRJ: 'gta-energie',
};

export const atomes = {
	'gta-vr3d': 'atome_vr3d.gltf',
	'gta-vm': 'atome_vm.gltf',
	'gta-ge': 'atome_ge.gltf',
	'gta-environement': 'atome_environement.gltf',
	'gta-energie': 'atome_energie.gltf',
	'gta-supports': 'atome_supports.gltf',
};
